
import { useState } from 'react';



import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Mbdharandsonjewellers from "../images/MBDHAR.jpg";
import Rupaecobrick from "../images/rupaecobrick.jpg";
import Manmohini from "../images/manmohibi.jpg";
import HOTEL_BERHAMPORELODGE from "../images/HOTEL_BERHAMPORE LODGE.jpg";

import Bimanbastralaya from "../images/bimanbastralaya.jpg";
import Umahardware from "../images/umahardware.jpg";
import apmcmicrofinance from "../images/APMC Micro Finance.jpg";

import Clasiktilesandmarbel from "../images/CLASIKTILES.jpg";
import Sarkarmedical from "../images/sarkarmedicalcentre.jpg";

import Psluxuryhotel from "../images/psluxuryhotel.jpg";
import vilasclubresort from "../images/www.vilasclubresort.com.jpg";

import hotelsangam from "../images/HOTELSANGAM.jpg";
import Paulshotelkrishnanagar from "../images/paulshotelkrishnagar.jpg";

import Drsankarkumarroy from "../images/drsankarkumarroy.jpg";
import prothamakrishnanagar from "../images/PROTHAMA - KRISHNAGAR.jpg";
import questdiagnosticskrishnanagar from "../images/QUEST DIAGNOSTICS KRISHNANAGAR.jpg";

import maatarafoundation from "../images/MAA TARA FOUNDATION.jpg";

import misaaberhampore from "../images/MISAA-LOGO.jpg";


import desertmina from "../images/Desertmina.jpg";
import MURSHIDABADZILAMAHILAURBAN from "../images/MURSHIDABAD ZILA MAHILA URBAN.jpg";
import thelovebirdsicecream from "../images/thelovebirds_icecream.jpg";
import aneektextiles from "../images/ANEEK TEXTILES.jpg";

import chuapukurict from "../images/CHUAPUKUR ISLAMIC CHARITABLE TRUST.jpg";


import MAK from "../images/mak.org.in.jpg";
import sushadu from "../images/sushadu.jpg";

import siddheswaribastralaya from "../images/siddheshwari bastralaya.jpg";

import smartpackersmovers from "../images/SMART_packersmovers.com.jpg";
import balajisaree from "../images/BALAJI SAREE.jpg";

import AristacureBiotech from "../images/Aristacure Biotech Private Limited.jpg";
import kpsnadia from "../images/Krishnagar Public School.jpg";

import atindiapackersmovers from "../images/AT INDIA PACKERS AND MOVERS.jpg"

import elitemedicalcare_krishnagar from "../images/Elite Medical care.jpg";
import lodgegreenhouse from "../images/Lodge Green House.jpg";
import asthadigitalservices from "../images/Astha Digital Services.jpg"
import BERHAMPORELASERSITTINGCENTRE from "../images/BERHAMPORE LASER SITTING CENTRE.jpg";
import srgcomplexkrishnagar from "../images/srg complex.jpg";
import unicornaerogreens from "../images/unicornaerogreens.jpg";

import aquadimonrosystem from "../images/AQUA DIMON RO SYSTEM.jpg";
import drrajkishoresarkar from "../images/DR. RAJKISHORE SARKAR.jpg";


import "./Develop.css";



function Silck() {


        const [show, setShow] = useState(false);
        const handleClose = () => setShow(false);
        const handleShow = () => setShow(true);

        const settings = {
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 3,
                slidesToScroll: 3
        };

        return (
                <div>



                        <div className="backgolor">
                                <div className='develop'>
                                        <center><h1 style={{ color: "white" }} className='mb-1'><b>OUR DEVELOPED WEBSITE</b></h1></center>
                                </div>
                                <div className="animat">
                                        <Slider {...settings}>

                                                <div>

                                                        <div className="card mb-4 border-White box ">
                                                                <div className="reactjsdeveloper">
                                                                        <a href='https://www.mbdharandsonjewellers.com/' target='_blank' rel="noopener noreferrer">
                                                                                <img src={Mbdharandsonjewellers} className="card-img-top" alt="Mbdharandsonjewellers" />
                                                                        </a>
                                                                </div>

                                                        </div>

                                                </div>

                                                <div>
                                                        <div className="card mb-4 border-White box ">
                                                                <div className="reactjsdeveloper">
                                                                        <a href='https://www.rupaecobrick.com/' target='_blank' rel="noopener noreferrer">
                                                                                <img src={Rupaecobrick} className="card-img-top" alt="Rupaecobrick" />
                                                                        </a>
                                                                </div>
                                                        </div>
                                                </div>

                                                <div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <a href='https://www.manmohini.com/' target='_blank' rel="noopener noreferrer">
                                                                                <img src={Manmohini} className="card-img-top" alt="Manmohini" />
                                                                        </a>

                                                                </div>
                                                        </div>
                                                </div>

                                                <div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <a href='https://bimanbastralaya.com/' target='_blank' rel="noopener noreferrer">
                                                                                <img src={Bimanbastralaya} className="card-img-top" alt="Bimanbastralaya" />
                                                                        </a>
                                                                </div>

                                                        </div>
                                                </div>

                                                <div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <a href='https://www.umahardware.in/' target='_blank' rel="noopener noreferrer">

                                                                                <img src={Umahardware} className="card-img-top" alt="Umahardware" />
                                                                        </a>
                                                                </div>
                                                        </div>
                                                </div>


                                                


                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.clasiktilesandmarbel.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={Clasiktilesandmarbel} className="card-img-top" alt="Clasiktilesandmarbel" />
                                                                </a>
                                                        </div>
                                                </div>


                                                <div>
                                                        <div className="card mb-4 border-White box">
                                                                <div className="reactjsdeveloper">
                                                                        <a href='https://www.sarkarmedical.in/' target='_blank' rel="noopener noreferrer">
                                                                                <img src={Sarkarmedical} className="card-img-top" alt="Kanbala" />
                                                                        </a>
                                                                </div>


                                                        </div>

                                                </div>
                                                <div className="card mb-4 border-White box">

                                                        <div className="reactjsdeveloper">
                                                                <a href='https://psluxuryhotel.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={Psluxuryhotel} className="card-img-top" alt="Psluxuryhotel" />
                                                                </a>
                                                        </div>
                                                </div>




                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.hotelsangams.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={hotelsangam} className="card-img-top" alt="hotelsangam" />
                                                                </a>
                                                        </div>                                        </div>


                                                <div className="card mb-4 border-White box ">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.paulshotel.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={Paulshotelkrishnanagar} className="card-img-top" alt="Paulshotelkrishnanagar" />
                                                                </a>
                                                        </div>
                                                </div>

                                                <div className="card mb-4 border-White box ">
                                                        <div className="reactjsdeveloper">

                                                                <a href='https://www.drsankarkumarroy.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={Drsankarkumarroy} className="card-img-top" alt="Drsankarkumarroy" />
                                                                </a>
                                                        </div>
                                                </div>

                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">

                                                                <a href='https://www.prothama.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={prothamakrishnanagar} className="card-img-top" alt="prothamakrishnanagar" />
                                                                </a>
                                                        </div>

                                                </div>
                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.questdiagnostics.org.in/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={questdiagnosticskrishnanagar} className="card-img-top" alt="questdiagnosticskrishnanagar" />
                                                                </a>
                                                        </div>
                                                </div>
                                          

                                               
                                               





                                                <div className="card mb-4 border-White box ">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.misaa.org.in/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={misaaberhampore} className="card-img-top" alt="misaaberhampore" />
                                                                </a>
                                                        </div>
                                                </div>







                                                <div className="card mb-4 border-White box ">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.desertmina.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={desertmina} className="card-img-top" alt="desertmina" />
                                                                </a>
                                                        </div>

                                                </div>

                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.mzmuccsl.in/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={MURSHIDABADZILAMAHILAURBAN} className="card-img-top" alt="desertmina" />
                                                                </a>
                                                        </div>
                                                </div>

                                                <div className="card mb-4 border-White box ">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.thelovebirdsicecream.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={thelovebirdsicecream} className="card-img-top" alt="thelovebirdsicecream" />
                                                                </a>
                                                        </div>
                                                </div>






                                                <div className="card mb-4 border-White box ">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.mak.org.in/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={MAK} className="card-img-top" alt="Mountaineers’ Association of Krishnanagar" />
                                                                </a>
                                                        </div>
                                                </div>

                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.sushadu.in/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={sushadu} className="card-img-top" alt="sushadu" />
                                                                </a>
                                                        </div>
                                                </div>






                                                <div className="card mb-4 border-White box ">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.hotelberhamporelodge.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={HOTEL_BERHAMPORELODGE} className="card-img-top" alt="HOTEL_BERHAMPORELODGE" />
                                                                </a>
                                                        </div>
                                                </div>
                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.siddheswaribastralaya.com/' target='_blank' rel="noopener noreferrer">

                                                                        <img src={siddheswaribastralaya} className="card-img-top" alt="siddheswaribastralaya" />
                                                                </a>
                                                        </div>

                                                </div>

                                               

                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.vilasclubresort.com/' target='_blank' rel="noopener noreferrer">

                                                                        <img src={vilasclubresort} className="card-img-top" alt="vilasclubresort" />
                                                                </a>
                                                        </div>

                                                </div>

                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">

                                                                <a href='https://mtfmurshidabad.org/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={maatarafoundation} className="card-img-top" alt="maatarafoundation" />
                                                                </a>
                                                        </div>
                                                </div>
                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.smartpackersmovers.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={smartpackersmovers} className="card-img-top" alt="smartpackersmovers" />
                                                                </a>
                                                        </div>

                                                </div>
                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.aneektextiles.in/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={aneektextiles} className="card-img-top" alt="aneektextiles" />
                                                                </a>
                                                        </div>

                                                </div>
                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.balajisaree.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={balajisaree} className="card-img-top" alt="balajisaree" />
                                                                </a>
                                                        </div>

                                                </div>

                                                
                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.aristacurebiotech.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={AristacureBiotech} className="card-img-top" alt="Aristacure Biotech Private Limted" />
                                                                </a>
                                                        </div>

                                                </div>
                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.kpsnadia.org/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={kpsnadia} className="card-img-top" alt="Krishnagar Public School" />
                                                                </a>
                                                        </div>

                                                </div>
                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.atindiapackersmovers.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={atindiapackersmovers} className="card-img-top" alt="AT INDIA PACKERS AND MOVERS" />
                                                                </a>
                                                        </div>

                                                </div>
                                                
                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.elite-medicalcare.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={elitemedicalcare_krishnagar} className="card-img-top" alt="Elite Medical Care Krishnagar" />
                                                                </a>
                                                        </div>

                                                </div>


                                                <div className="card mb-4 border-White box ">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.chuapukurict.org/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={chuapukurict} className="card-img-top" alt="CHUAPUKUR ISLAMIC CHARITABLE TRUST" />
                                                                </a>
                                                        </div>
                                                </div>

                                                <div className="card mb-4 border-White box ">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://lodgegreenhouse.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={lodgegreenhouse} className="card-img-top" alt="lodgegreenhouse" />
                                                                </a>
                                                        </div>
                                                </div>
                                                <div className="card mb-4 border-White box ">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.asthadigitalservices.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={asthadigitalservices} className="card-img-top" alt="asthadigitalservices"/>
                                                                </a>
                                                        </div>
                                                </div>

<div className="card mb-4 border-White box ">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.berhamporelsc.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={BERHAMPORELASERSITTINGCENTRE} className="card-img-top" alt="BERHAMPORELASERSITTINGCENTRE" />
                                                                </a>
                                                        </div>
                                                </div>
                                                <div className="card mb-4 border-White box ">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://srgcomplex.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={srgcomplexkrishnagar} className="card-img-top" alt="srgcomplex krishnagar" />
                                                                </a>
                                                        </div>
                                                </div>

                                                <div className="card mb-4 border-White box ">
                                                        <div className="reactjsdeveloper">
                                                                <a href='https://www.unicornaerogreens.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={unicornaerogreens} className="card-img-top" alt="unicornaerogreens" />
                                                                </a>
                                                        </div>
                                                </div>
                                                <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href=' https://www.apmcmicrofinance.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={apmcmicrofinance} className="card-img-top" alt="apmcmicrofinance" />
                                                                </a>
                                                        </div>

                                                </div>

 <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href=' https://www.aquadimonro.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={aquadimonrosystem} className="card-img-top" alt="aquadimonrosystem" />
                                                                </a>
                                                        </div>

                                                </div>
                                                 <div className="card mb-4 border-White box">
                                                        <div className="reactjsdeveloper">
                                                                <a href=' https://www.drrajkishoresarkar.com/' target='_blank' rel="noopener noreferrer">
                                                                        <img src={drrajkishoresarkar} className="card-img-top" alt="drrajkishoresarkar" />
                                                                </a>
                                                        </div>

                                                </div>
                                        </Slider>
                                </div>
                                <br />
                        </div>
                        <br />



                </div>
        )
}



export default Silck